require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// ../~/angular-touch/index.js
// module id = 335
// module chunks = 0